import { render, staticRenderFns } from "./ManageFeatureExpansion.vue?vue&type=template&id=24922040&scoped=true"
import script from "./ManageFeatureExpansion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageFeatureExpansion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ManageFeatureExpansion.vue?vue&type=style&index=0&id=24922040&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24922040",
  null
  
)

export default component.exports